import React from 'react';
import classNames from 'classnames';
import { Trash } from '@styled-icons/feather';
import { InterpreterFrom } from 'xstate';
import { useActor } from '@xstate/react';
import styles from '../Navbar.module.css';
import { NavbarContainerOptionsMachineType } from '../../../nodes/navbar/fsm/NavbarContainer.fsm';
import { Popup } from '../../../components/Popup/Popup';

export function NavbarRemoveOption(props: {
  machine: InterpreterFrom<NavbarContainerOptionsMachineType>;
}) {
  const { machine } = props;
  const [machineState, machineSend] = useActor(machine);

  return (
    <>
      <div
        className={styles.navbarOptions}
        onClick={() =>
          machineSend({
            type: 'NAVBAR.REMOVE.SHOW_DIALOG',
          })
        }
        role="none"
        data-testid="NavbarToolbar_Remove"
      >
        <div className={classNames(styles.navbarOptionsTitle, styles.navbarOptionsTitleButton)}>
          Remove
          <Trash size={15} style={{ marginLeft: 5 }} />
        </div>
      </div>
      <Popup
        height={260}
        width={400}
        open={machineState.hasTag('ui:show_delete_navbar_dialog')}
        setopen={(open) => {
          if (!open) {
            machineSend({ type: 'NAVBAR.REMOVE.CANCEL' });
          }
        }}
        className="p-6"
      >
        <div className="is-size-6 with-text-color mb-3">Delete the navbar of this project?</div>
        <hr />
        <div className="is-subtitle with-light-text-color mb-3">This action cannot be undone.</div>
        <button
          type="button"
          className={classNames(
            'button',
            'is-danger',
            'with-danger-transparent-background-color',
            'with-danger-text-color',
            'has-font-weight-normal',
            'mt-2'
          )}
          data-testid="NavbarToolbar_Remove_Confirm"
          onClick={() =>
            machineSend({
              type: 'NAVBAR.REMOVE.CONFIRM',
            })
          }
        >
          Remove navbar
        </button>
      </Popup>
    </>
  );
}
